module.exports = __webpack_public_path__ + "img/tonghua0.be6aec2e.png";